/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import {
    Button,
    CircularProgress,
    Divider,
    Grid,
    Paper,
    Theme,
    Typography,
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import { EditOutlined } from "@material-ui/icons";
import { Trans, useTranslation } from "react-i18next";
import { IAnnounce } from "../../../utils/AnnounceInterfaces";
import { PreviewPhotosReservation } from "../../Properties/components/PreviewPhotos/PreviewPhotosReservation";
import {
    createMarkup,
    getDayNumber,
    getDayNumberProm,
    useQuery,
} from "../../../utils/App";
import {
    CurrencyContext,
    ReservationContext,
} from "../../../contexts/AppContext";
import SaveIcon from "@mui/icons-material/Save";
import { PnbQtePicker } from "../../Announces/components/ReservationCard";
import { useHistory } from "react-router";
import CancelIcon from "@mui/icons-material/Cancel";
import { IReservation } from "../../../utils/ReservationInterfaces";
import { PnBDateRange } from "../../components/PnBDateRange";
import { serverConfig } from "../../../utils/config";
import { IUserService } from "../../../Services/userServecesServices";
import {
    ConvertedDeviseWithMoneySign,
    ConvertedDeviseWithoutMoneySign,
    ConvertPrice,
} from "../../../utils/CurrencyConvertFunction";
import { ConfirmationReservationService } from "../services/ConfirmationReservationService";
import { colors } from "../../../styles/defaultColors";
import moment from "moment";
import { ETarifs, getTarifLabel } from "../../../utils/enum";
import i18n from "../../../i18n/config";
import 'moment/locale/fr'; // French locale
import 'moment/locale/en-gb'; // Optional: use 'en' or 'en-gb' for British English

const Env = serverConfig;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        img: {
            borderRadius: "4px",
        },
        previewPhotos: {
            display: "block",
            borderRadius: "4px",
            width: "100%",
        },
        simpleText: {
            fontSize: 16,
            fontWeight: 300,
            lineHeight: "20px",
        },
        emphasizedText: {
            fontSize: "1rem",
            fontWeight: 400,
            lineHeight: "20px",
        },
        notes: {
            marginRight: 14,
            fontSize: 14,
            color: "#890608",
        },
        pointIcon: {
            fontSize: 6,
            marginLeft: 16,
            marginRight: 14,
        },
        comments: {
            marginLeft: 14,
        },
        errors: {
            color: colors.danger,
            background: colors.backgroundDanger,
            width: "100%",
            textAlign: "center",
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            borderRadius: 5,
            "& p": {
                padding: 10,
            },
        },
        root: {
            [theme.breakpoints.down("sm")]: {
                marginBottom: 50,
            },
        },
    })
);

interface DurationValues {
    trs_duration_days: number;
    trs_duration_hours: number;
    trs_duration_minutes: number;
}    

const reservationService = new ConfirmationReservationService();
export const ConfirmReservationCard = (props: {
    announce: IAnnounce;
    userServices: IUserService[];
    selectedServices: string[];
    setUpdatePaymentData: (value: boolean) => void;
    cond: boolean;
    setTotalPaye: any;
    paidByCredit?: number;
    advancePaymentPercentage: number;
}) => {
    let query = useQuery();
    const history = useHistory();
    const ADVANCE_PAYMENT_PERCENTAGE = props.advancePaymentPercentage;     
    const reservationContext = useContext(ReservationContext);
    const { reservation, setReservation } = reservationContext;
    const [oldReservationValue] = React.useState<IReservation>(reservation);
    const [isUpdatingTraveller, setIsUpdatingTraveller] =
        React.useState<boolean>(false);
    const [isUpdatingDates, setIsUpdatingDates] =
        React.useState<boolean>(false);
    const currencyContext = useContext(CurrencyContext);
    const { currency } = currencyContext;
    const [priceConverted, setPriceConverted] = React.useState<number>(0);
    const [priceConvertedProm, setPriceConvertedProm] =
        React.useState<number>(0);
    const [priceConvertedSimple, setPriceConvertedSimple] =
        React.useState<number>(0);
    const [DayPrice, setDayPrice] = React.useState(0);
    const [DayPriceProm, setDayPriceProm] = React.useState(0);
    const [, setServicePrice] = React.useState(0);
    const [servicePriceAppli, setServicePriceAppli] = React.useState(0);
    const [cleaningFee, setCleaningFee] = React.useState(0);
    const [totalPrice, setTotalPrice] = React.useState<number>(0);
    const [creditUsed, setCreditUsed] = React.useState<number>(0);
    const [halfTotalPrice, setHalfTotalPrice] = React.useState<number>(0);
    const [totalPriceProm, setTotalPriceProm] = React.useState<number>(0);
    const [, setCommissionFee] = React.useState<number>(0);
    const [nbJourProm, setNbJourProm] = React.useState<number>(1);
    const [nbJourSimple, setNbJourSimple] = React.useState<number>(1);
    const [nbJours, setNbJours] = React.useState(getDayNumber(query.get("dci") || '' , query.get("dco") || ''));
    const [tarif, setTarif] = React.useState(ETarifs.JOURNALIER);
    const [paidByCreditConverted, setPaidByCreditConverted] = React.useState<number>(0);
    const [advancePayment, setAdvancePayment] = React.useState<number>(0);
    const [advancePaymentFormatted, setAdvancePaymentFormatted] = React.useState<string>('');
    const [balancePayment, setBalancePayment] = React.useState<number>(0);
    const [balancePaymentFormatted, setBalancePaymentFormatted] = React.useState<string>('');
    const [totalPriceFormatted, setTotalPriceFormatted] = React.useState<string>('');
    const [isCalculating, setIsCalculating] = React.useState(false);
    const [halfTotalPriceFormatted, setHalfTotalPriceFormatted] = React.useState<string>('');
    const searchType = props.announce?.property?.type?.searchType?.name
    let nbjours_prom: number;
    let nbjours_simple: number;
    let nbJour: number;
    moment.locale(i18n.language); // 'fr' or 'en'
    if ((query.get("dco") || "") && (query.get("dci") || "")) {
        var msMinute = 60 * 1000,
            msDay = 60 * 60 * 24 * 1000,
            a: any = new Date(query.get("dci") || ""),
            b: any = new Date(query.get("dco") || "");
        nbjours_simple = Math.floor((b - a) / msDay);
    }
    if (props.announce.promotion) {
        nbjours_prom = getDayNumberProm(
            query.get("dci") || "",
            query.get("dco") || "",
            moment(props.announce.promotion.startDate).format("YYYY-MM-DD"),
            moment(props.announce.promotion.endDate).format("YYYY-MM-DD"),
            props.announce.price,
            props.announce.promotion.price
        ).DateProm;
        nbjours_simple = getDayNumberProm(
            query.get("dci") || "",
            query.get("dco") || "",
            moment(props.announce.promotion.startDate).format("YYYY-MM-DD"),
            moment(props.announce.promotion.endDate).format("YYYY-MM-DD"),
            props.announce.price,
            props.announce.promotion.price
        ).DateSimple;
        nbJour = nbJourSimple + nbJourProm;
    }
    React.useEffect(() => {
        if (props.announce.promotion) {
            setNbJourProm(nbjours_prom);
            setNbJourSimple(nbjours_simple);
            if (nbJour > 0) setNbJours (nbJour);
        } else {
            if (query.get("dci") !== null && query.get("dco")!==null && (getDayNumber(query.get("dci") || '' , query.get("dco") || '') !== 0))
            setNbJours(
                getDayNumber(query.get("dci") || '' , query.get("dco") || '')
            );
        }
    }, [query.get("dci"), query.get("dco"), props.announce]);

    
    React.useEffect(() => {
        ConvertedDeviseWithoutMoneySign(
            "XAF",
            currency,
            getTotalFraiService()
        ).then((ser: any) => setServicePriceAppli(ser));
        let percentage = 0;
        if (props.announce.property.type.name === "Hôtel") {
            reservationService
                .getSpecialFeeByPropertyType(props.announce.property.type.name)
                .then((response) => {
                    if (response.success) {
                        if (props.userServices.length > 0) {
                            ConvertedDeviseWithoutMoneySign(
                                "XAF",
                                props.announce.devise,
                                getTotalFraiService()
                            )
                                .then((serviceVal: any): any => {
                                    setServicePrice(serviceVal);

                                    percentage = response.data
                                        ? response.data.percentageTraveller
                                        : 0;
                                    setCommissionFee(percentage);
                                    let normalPriceProm;
                                    let normalPriceWithDaysProm;
                                    let normalPriceWithDaysWithCleaningFeesProm;
                                    let normalPriceWithDaysSimple;
                                    let normalPrice;
                                    if (
                                        nbJours >= 7 &&
                                        nbJours < 14 &&
                                        props.announce.priceWeekly &&
                                        props.announce.priceWeekly > 0
                                    ) {
                                        normalPrice = (
                                            props.announce.priceWeekly / 7 +
                                            (props.announce.priceWeekly / 7) *
                                                (percentage / 100)
                                        ).toFixed(2);
                                        setTarif(ETarifs.HEBDOMADAIRE);
                                    } else if (
                                        nbJours >= 14 &&
                                        nbJours < 30 &&
                                        props.announce.priceBiWeekly &&
                                        props.announce.priceBiWeekly > 0
                                    ) {
                                        normalPrice = (
                                            props.announce.priceBiWeekly / 14 +
                                            (props.announce.priceBiWeekly /
                                                14) *
                                                (percentage / 100)
                                        ).toFixed(2);
                                        setTarif(ETarifs.QUINZAINE);
                                    } else if (
                                        nbJours >= 30 &&
                                        props.announce.priceMonthly &&
                                        props.announce.priceMonthly > 0
                                    ) {
                                        normalPrice = (
                                            props.announce.priceMonthly / 30 +
                                            (props.announce.priceMonthly / 30) *
                                                (percentage / 100)
                                        ).toFixed(2);
                                        setTarif(ETarifs.MENSUEL);
                                    } else {
                                        normalPrice = (
                                            props.announce.price +
                                            props.announce.price *
                                                (percentage / 100)
                                        ).toFixed(2);
                                        setTarif(ETarifs.JOURNALIER);
                                    }
                                    if (props.announce.promotion) {
                                        normalPriceProm = (
                                            props.announce.promotion.price +
                                            props.announce.promotion.price *
                                                (percentage / 100)
                                        ).toFixed(2);
                                        normalPriceWithDaysProm = (
                                            nbJourProm * Number(normalPriceProm)
                                        ).toFixed(2); /*change*/
                                        normalPriceWithDaysSimple = (
                                            nbJourSimple * Number(normalPrice)
                                        ).toFixed(2); /*change*/
                                        normalPriceWithDaysWithCleaningFeesProm =
                                            Number(normalPriceWithDaysSimple) +
                                            Number(normalPriceWithDaysProm) +
                                            (props.announce.cleaningFees +
                                                props.announce.cleaningFees *
                                                    (percentage / 100)) +
                                            Number(serviceVal);
                                    }
                                    ConvertedDeviseWithMoneySign(
                                        props.announce.devise || "XAF",
                                        currency,
                                        Number(normalPriceProm)
                                    )
                                        .then((value: any): any =>
                                            setPriceConvertedProm(value)
                                        )
                                        .catch((error) => console.log(error));
                                    ConvertedDeviseWithMoneySign(
                                        props.announce.devise || "XAF",
                                        currency,
                                        Number(normalPriceWithDaysSimple)
                                    )
                                        .then((value: any): any =>
                                            setPriceConvertedSimple(value)
                                        )
                                        .catch((error) =>
                                            console.log(error)
                                        ); /*change*/

                                    ConvertedDeviseWithMoneySign(
                                        props.announce.devise || "XAF",
                                        currency,
                                        Number(normalPriceWithDaysProm)
                                    )
                                        .then((value: any): any =>
                                            setDayPriceProm(value)
                                        )
                                        .catch((error) => console.log(error));

                                    ConvertedDeviseWithMoneySign(
                                        props.announce.devise || "XAF",
                                        currency,
                                        Number(
                                            normalPriceWithDaysWithCleaningFeesProm
                                        )
                                    )
                                        .then((value: any): any =>
                                            setTotalPriceProm(value)
                                        )
                                        .catch((error) => console.log(error));

                                    ConvertedDeviseWithMoneySign(
                                        props.announce.devise || "XAF",
                                        currency,
                                        Number(normalPrice)
                                    )
                                        .then((value: any): any =>
                                            setPriceConverted(value)
                                        )
                                        .catch((error) => console.log(error));

                                    const normalPriceWithDays = (
                                        getDayNumber(
                                            reservation.dateCheckIn,
                                            reservation.dateCheckOut
                                        ) * Number(normalPrice)
                                    ).toFixed(2);
                                    ConvertedDeviseWithMoneySign(
                                        props.announce.devise || "XAF",
                                        currency,
                                        Number(normalPriceWithDays)
                                    )
                                        .then((value: any): any =>
                                            setDayPrice(value)
                                        )
                                        .catch((error) => console.log(error));

                                    ConvertedDeviseWithMoneySign(
                                        props.announce.devise || "XAF",
                                        currency,
                                        props.announce.cleaningFees +
                                            props.announce.cleaningFees *
                                                (percentage / 100)
                                    )
                                        .then((value: any): any =>
                                            setCleaningFee(value)
                                        )
                                        .catch((error) => console.log(error));

                                    const normalPriceWithDaysWithCleaningFees =
                                        Number(normalPriceWithDays) +
                                        (props.announce.cleaningFees +
                                            props.announce.cleaningFees *
                                                (percentage / 100)) +
                                        Number(serviceVal);

                                    // console.log("ty no ilaina ",normalPriceWithDaysWithCleaningFees)
                                    // props.setTotalPaye(Number(normalPriceWithDaysWithCleaningFees))
                                    ConvertedDeviseWithoutMoneySign(
                                        props.announce.devise,
                                        "XAF",
                                        Number(normalPriceWithDaysWithCleaningFees)
                                    )
                                    .then((value) => {
                                        props.setTotalPaye(Number(value));
                                        const priceWithCredit = Number(value) - (props.paidByCredit ?? 0);
                                        
                                        // Calculate payments based on percentage
                                        const numericAdvance = (priceWithCredit * ADVANCE_PAYMENT_PERCENTAGE) / 100;
                                        const numericBalance = priceWithCredit - numericAdvance;
                                        
                                        setTotalPrice(priceWithCredit);
                                        setAdvancePayment(numericAdvance);
                                        setBalancePayment(numericBalance);
                                        
                                        // Get formatted versions
                                        ConvertedDeviseWithMoneySign("XAF", currency, priceWithCredit)
                                            .then(setTotalPriceFormatted)
                                            .catch(console.error);
                                        
                                        ConvertedDeviseWithMoneySign("XAF", currency, numericAdvance)
                                            .then(setAdvancePaymentFormatted)
                                            .catch(console.error);
                                            
                                        ConvertedDeviseWithMoneySign("XAF", currency, numericBalance)
                                            .then(setBalancePaymentFormatted)
                                            .catch(console.error);
                                    })
                                    .catch(console.error);
                                    if (
                                        props.paidByCredit &&
                                        props.paidByCredit > 0
                                    )
                                        ConvertedDeviseWithMoneySign(
                                            "XAF",
                                            currency,
                                            props.paidByCredit
                                        )
                                            .then((value: any): any =>
                                                setPaidByCreditConverted(value)
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                })
                                .catch((error) => console.log(error));
                        } else {
                            // console.log("tafiditra ato ve sa kosa ato")
                            percentage = response.data
                                ? response.data.percentageTraveller
                                : 0;
                            setCommissionFee(percentage);
                            let normalPriceProm;
                            let normalPriceWithDaysProm;
                            let normalPriceWithDaysWithCleaningFeesProm;
                            let normalPriceWithDaysSimple;
                            // const normalPrice=(props.announce.price +(props.announce.price * (percentage/100))).toFixed(2)
                            let normalPrice;
                            if (
                                nbJours >= 7 &&
                                nbJours < 14 &&
                                props.announce.priceWeekly &&
                                props.announce.priceWeekly > 0
                            ) {
                                normalPrice = (
                                    props.announce.priceWeekly / 7 +
                                    (props.announce.priceWeekly / 7) *
                                        (percentage / 100)
                                ).toFixed(2);
                                setTarif(ETarifs.HEBDOMADAIRE);
                            } else if (
                                nbJours >= 14 &&
                                nbJours < 30 &&
                                props.announce.priceBiWeekly &&
                                props.announce.priceBiWeekly > 0
                            ) {
                                normalPrice = (
                                    props.announce.priceBiWeekly / 14 +
                                    (props.announce.priceBiWeekly / 14) *
                                        (percentage / 100)
                                ).toFixed(2);
                                setTarif(ETarifs.QUINZAINE);
                            } else if (
                                nbJours >= 30 &&
                                props.announce.priceMonthly &&
                                props.announce.priceMonthly > 0
                            ) {
                                normalPrice = (
                                    props.announce.priceMonthly / 30 +
                                    (props.announce.priceMonthly / 30) *
                                        (percentage / 100)
                                ).toFixed(2);
                                setTarif(ETarifs.MENSUEL);
                            } else {
                                normalPrice = (
                                    props.announce.price +
                                    props.announce.price * (percentage / 100)
                                ).toFixed(2);
                                setTarif(ETarifs.JOURNALIER);
                            }
                            if (props.announce.promotion) {
                                // const normalPriceSimple=(props.announce.price +(props.announce.price * (percentage/100))).toFixed(2)
                                normalPriceProm = (
                                    props.announce.promotion.price +
                                    props.announce.promotion.price *
                                        (percentage / 100)
                                ).toFixed(2);
                                normalPriceWithDaysProm = (
                                    nbJourProm * Number(normalPriceProm)
                                ).toFixed(2); /*change*/
                                normalPriceWithDaysSimple = (
                                    nbJourSimple * Number(normalPrice)
                                ).toFixed(2); /*change*/
                                normalPriceWithDaysWithCleaningFeesProm =
                                    Number(normalPriceWithDaysSimple) +
                                    Number(normalPriceWithDaysProm) +
                                    (props.announce.cleaningFees +
                                        props.announce.cleaningFees *
                                            (percentage / 100)) +
                                    getTotalFraiService();
                            }
                            ConvertedDeviseWithMoneySign(
                                props.announce.devise || "XAF",
                                currency,
                                Number(normalPriceProm)
                            )
                                .then((value: any): any =>
                                    setPriceConvertedProm(value)
                                )
                                .catch((error) => console.log(error));

                            ConvertedDeviseWithMoneySign(
                                props.announce.devise || "XAF",
                                currency,
                                Number(normalPriceWithDaysSimple)
                            )
                                .then((value: any): any =>
                                    setPriceConvertedSimple(value)
                                )
                                .catch((error) =>
                                    console.log(error)
                                ); /*change*/

                            ConvertedDeviseWithMoneySign(
                                props.announce.devise || "XAF",
                                currency,
                                Number(normalPriceWithDaysProm)
                            )
                                .then((value: any): any =>
                                    setDayPriceProm(value)
                                )
                                .catch((error) => console.log(error));

                            ConvertedDeviseWithMoneySign(
                                props.announce.devise || "XAF",
                                currency,
                                Number(normalPriceWithDaysWithCleaningFeesProm)
                            )
                                .then((value: any): any =>
                                    setTotalPriceProm(value)
                                )
                                .catch((error) => console.log(error));

                            ConvertedDeviseWithMoneySign(
                                props.announce.devise || "XAF",
                                currency,
                                Number(normalPrice)
                            )
                                .then((value: any): any =>
                                    setPriceConverted(value)
                                )
                                .catch((error) => console.log(error));

                            const normalPriceWithDays = (
                                getDayNumber(
                                    reservation.dateCheckIn,
                                    reservation.dateCheckOut
                                ) * Number(normalPrice)
                            ).toFixed(2);
                            ConvertedDeviseWithMoneySign(
                                props.announce.devise || "XAF",
                                currency,
                                Number(normalPriceWithDays)
                            )
                                .then((value: any): any => setDayPrice(value))
                                .catch((error) => console.log(error));

                            ConvertedDeviseWithMoneySign(
                                props.announce.devise || "XAF",
                                currency,
                                props.announce.cleaningFees +
                                    props.announce.cleaningFees *
                                        (percentage / 100)
                            )
                                .then((value: any): any =>
                                    setCleaningFee(value)
                                )
                                .catch((error) => console.log(error));

                            const normalPriceWithDaysWithCleaningFees =
                                Number(normalPriceWithDays) +
                                (props.announce.cleaningFees +
                                    props.announce.cleaningFees *
                                        (percentage / 100)) +
                                getTotalFraiService();

                            // console.log(
                            //     "ty no ilaina ",
                            //     normalPriceWithDaysWithCleaningFees
                            // );
                            ConvertPrice(
                                props.announce.devise,
                                "XAF",
                                Number(normalPriceWithDaysWithCleaningFees)
                            )
                                .then((value) => {
                                    props.setTotalPaye(Number(value));
                                    const priceWithCredit =
                                        Number(value) -
                                        (props.paidByCredit ?? 0);
                                        ConvertedDeviseWithoutMoneySign(
                                            props.announce.devise,
                                            "XAF",
                                            Number(normalPriceWithDaysWithCleaningFees)
                                        )
                                        .then((value) => {
                                            props.setTotalPaye(Number(value));
                                            const priceWithCredit = Number(value) - (props.paidByCredit ?? 0);
                                            
                                            // Calculate payments based on percentage
                                            const numericAdvance = (priceWithCredit * ADVANCE_PAYMENT_PERCENTAGE) / 100;
                                            const numericBalance = priceWithCredit - numericAdvance;
                                            
                                            setTotalPrice(priceWithCredit);
                                            setAdvancePayment(numericAdvance);
                                            setBalancePayment(numericBalance);
                                            
                                            // Get formatted versions
                                            ConvertedDeviseWithMoneySign("XAF", currency, priceWithCredit)
                                                .then(setTotalPriceFormatted)
                                                .catch(console.error);
                                            
                                            ConvertedDeviseWithMoneySign("XAF", currency, numericAdvance)
                                                .then(setAdvancePaymentFormatted)
                                                .catch(console.error);
                                                
                                            ConvertedDeviseWithMoneySign("XAF", currency, numericBalance)
                                                .then(setBalancePaymentFormatted)
                                                .catch(console.error);
                                        })
                                        .catch(console.error);
                                })
                                .catch((error) => console.log(error));
                            if (props.paidByCredit && props.paidByCredit > 0)
                                ConvertedDeviseWithMoneySign(
                                    "XAF",
                                    currency,
                                    props.paidByCredit
                                )
                                    .then((value: any): any =>
                                        setPaidByCreditConverted(value)
                                    )
                                    .catch((error) => console.log(error));
                        }
                    }
                });
        } else {
            reservationService
                .getCommissionFeeByCountryAndCityId(
                    props.announce.property?.address?.country?.name,
                    props.announce.property?.address?.city?.name 
                )
                .then((respCom) => {
                    if (respCom.success) {
                        if (props.userServices.length > 0) {
                            ConvertedDeviseWithoutMoneySign(
                                "XAF",
                                props.announce.devise,
                                getTotalFraiService()
                            )
                                .then((serviceVal: any): any => {
                                    setServicePrice(serviceVal);

                                    percentage = respCom.data
                                        ? respCom.data.percentage
                                        : 0;
                                    setCommissionFee(percentage);
                                    let normalPriceProm;
                                    let normalPriceWithDaysProm;
                                    let normalPriceWithDaysWithCleaningFeesProm;
                                    let normalPriceWithDaysSimple;
                                    let normalPrice;
                                    if (
                                        nbJours >= 7 &&
                                        nbJours < 14 &&
                                        props.announce.priceWeekly &&
                                        props.announce.priceWeekly > 0
                                    ) {
                                        normalPrice = (
                                            props.announce.priceWeekly / 7 +
                                            (props.announce.priceWeekly / 7) *
                                                (percentage / 100)
                                        ).toFixed(2);
                                        setTarif(ETarifs.HEBDOMADAIRE);
                                    } else if (
                                        nbJours >= 14 &&
                                        nbJours < 30 &&
                                        props.announce.priceBiWeekly &&
                                        props.announce.priceBiWeekly > 0
                                    ) {
                                        normalPrice = (
                                            props.announce.priceBiWeekly / 14 +
                                            (props.announce.priceBiWeekly /
                                                14) *
                                                (percentage / 100)
                                        ).toFixed(2);
                                        setTarif(ETarifs.QUINZAINE);
                                    } else if (
                                        nbJours >= 30 &&
                                        props.announce.priceMonthly &&
                                        props.announce.priceMonthly > 0
                                    ) {
                                        normalPrice = (
                                            props.announce.priceMonthly / 30 +
                                            (props.announce.priceMonthly / 30) *
                                                (percentage / 100)
                                        ).toFixed(2);
                                        setTarif(ETarifs.MENSUEL);
                                    } 
                                    else {
                                        normalPrice = (
                                            props.announce.price +
                                            props.announce.price *
                                                (percentage / 100)
                                        ).toFixed(2);
                                        setTarif(ETarifs.JOURNALIER);
                                    }
                                    if (props.announce.promotion) {
                                        normalPriceProm = (
                                            props.announce.promotion.price +
                                            props.announce.promotion.price *
                                                (percentage / 100)
                                        ).toFixed(2);
                                        normalPriceWithDaysProm = (
                                            nbJourProm * Number(normalPriceProm)
                                        ).toFixed(2); /*change*/
                                        normalPriceWithDaysSimple = (
                                            nbJourSimple * Number(normalPrice)
                                        ).toFixed(2); /*change*/
                                        normalPriceWithDaysWithCleaningFeesProm =
                                            Number(normalPriceWithDaysSimple) +
                                            Number(normalPriceWithDaysProm) +
                                            (props.announce.cleaningFees +
                                                props.announce.cleaningFees *
                                                    (percentage / 100)) +
                                            Number(serviceVal);
                                    }
                                    ConvertedDeviseWithMoneySign(
                                        props.announce.devise || "XAF",
                                        currency,
                                        Number(normalPriceProm)
                                    )
                                        .then((value: any): any =>
                                            setPriceConvertedProm(value)
                                        )
                                        .catch((error) => console.log(error));
                                    ConvertedDeviseWithMoneySign(
                                        props.announce.devise || "XAF",
                                        currency,
                                        Number(normalPriceWithDaysSimple)
                                    )
                                        .then((value: any): any =>
                                            setPriceConvertedSimple(value)
                                        )
                                        .catch((error) =>
                                            console.log(error)
                                        ); /*change*/

                                    ConvertedDeviseWithMoneySign(
                                        props.announce.devise || "XAF",
                                        currency,
                                        Number(normalPriceWithDaysProm)
                                    )
                                        .then((value: any): any =>
                                            setDayPriceProm(value)
                                        )
                                        .catch((error) => console.log(error));

                                    ConvertedDeviseWithMoneySign(
                                        props.announce.devise || "XAF",
                                        currency,
                                        Number(
                                            normalPriceWithDaysWithCleaningFeesProm
                                        )
                                    )
                                        .then((value: any): any =>
                                            setTotalPriceProm(value)
                                        )
                                        .catch((error) => console.log(error));

                                    ConvertedDeviseWithMoneySign(
                                        props.announce.devise || "XAF",
                                        currency,
                                        Number(normalPrice)
                                    )
                                        .then((value: any): any =>
                                            setPriceConverted(value)
                                        )
                                        .catch((error) => console.log(error));

                                    const normalPriceWithDays = (
                                        getDayNumber(
                                            reservation.dateCheckIn,
                                            reservation.dateCheckOut
                                        ) * Number(normalPrice)
                                    ).toFixed(2);
                                    ConvertedDeviseWithMoneySign(
                                        props.announce.devise || "XAF",
                                        currency,
                                        Number(normalPriceWithDays)
                                    )
                                        .then((value: any): any =>
                                            setDayPrice(value)
                                        )
                                        .catch((error) => console.log(error));

                                    ConvertedDeviseWithMoneySign(
                                        props.announce.devise || "XAF",
                                        currency,
                                        props.announce.cleaningFees +
                                            props.announce.cleaningFees *
                                                (percentage / 100)
                                    )
                                        .then((value: any): any =>
                                            setCleaningFee(value)
                                        )
                                        .catch((error) => console.log(error));

                                    const normalPriceWithDaysWithCleaningFees =
                                        Number(normalPriceWithDays) +
                                        (props.announce.cleaningFees +
                                            props.announce.cleaningFees *
                                                (percentage / 100)) +
                                        Number(serviceVal);
                                    // console.log("ty no ilaina ",normalPriceWithDaysWithCleaningFees)
                                    // props.setTotalPaye(Number(normalPriceWithDaysWithCleaningFees))
                                    ConvertedDeviseWithoutMoneySign(
                                        props.announce.devise,
                                        "XAF",
                                        Number(
                                            normalPriceWithDaysWithCleaningFees
                                        )
                                    )
                                        .then((value) => {
                                            const priceWithCredit =
                                                Number(value) -
                                                (props.paidByCredit ?? 0);
                                            props.setTotalPaye(Number(value));
                                            ConvertedDeviseWithoutMoneySign(
                                                props.announce.devise,
                                                "XAF",
                                                Number(normalPriceWithDaysWithCleaningFees)
                                            )
                                            .then((value) => {
                                                props.setTotalPaye(Number(value));
                                                const priceWithCredit = Number(value) - (props.paidByCredit ?? 0);
                                                
                                                // Calculate payments based on percentage
                                                const numericAdvance = (priceWithCredit * ADVANCE_PAYMENT_PERCENTAGE) / 100;
                                                const numericBalance = priceWithCredit - numericAdvance;
                                                
                                                setTotalPrice(priceWithCredit);
                                                setAdvancePayment(numericAdvance);
                                                setBalancePayment(numericBalance);
                                                
                                                // Get formatted versions
                                                ConvertedDeviseWithMoneySign("XAF", currency, priceWithCredit)
                                                    .then(setTotalPriceFormatted)
                                                    .catch(console.error);
                                                
                                                ConvertedDeviseWithMoneySign("XAF", currency, numericAdvance)
                                                    .then(setAdvancePaymentFormatted)
                                                    .catch(console.error);
                                                    
                                                ConvertedDeviseWithMoneySign("XAF", currency, numericBalance)
                                                    .then(setBalancePaymentFormatted)
                                                    .catch(console.error);
                                            })
                                            .catch(console.error);
                                        })
                                        .catch((error) => console.log(error));
                                })
                                .catch((error) => console.log(error));
                            if (props.paidByCredit && props.paidByCredit > 0)
                                ConvertedDeviseWithMoneySign(
                                    "XAF",
                                    currency,
                                    props.paidByCredit
                                )
                                    .then((value: any): any =>
                                        setPaidByCreditConverted(value)
                                    )
                                    .catch((error) => console.log(error));
                        } else {
                            // console.log("tafiditra ato ve sa kosa ato")
                            percentage = respCom.data
                                ? respCom.data.percentage
                                : 0;
                            setCommissionFee(percentage);
                            let normalPriceProm;
                            let normalPriceWithDaysProm;
                            let normalPriceWithDaysWithCleaningFeesProm;
                            let normalPriceWithDaysSimple;
                            // const normalPrice=(props.announce.price +(props.announce.price * (percentage/100))).toFixed(2)
                            let normalPrice;
                            if (
                                nbJours >= 7 &&
                                nbJours < 14 &&
                                props.announce.priceWeekly &&
                                props.announce.priceWeekly > 0
                            ) {
                                normalPrice = (
                                    props.announce.priceWeekly / 7 +
                                    (props.announce.priceWeekly / 7) *
                                        (percentage / 100)
                                ).toFixed(2);
                                setTarif(ETarifs.HEBDOMADAIRE);
                            } else if (
                                nbJours >= 14 &&
                                nbJours < 30 &&
                                props.announce.priceBiWeekly &&
                                props.announce.priceBiWeekly > 0
                            ) {
                                normalPrice = (
                                    props.announce.priceBiWeekly / 14 +
                                    (props.announce.priceBiWeekly / 14) *
                                        (percentage / 100)
                                ).toFixed(2);
                                setTarif(ETarifs.QUINZAINE);
                            } else if (
                                nbJours >= 30 &&
                                props.announce.priceMonthly &&
                                props.announce.priceMonthly > 0
                            ) {
                                normalPrice = (
                                    props.announce.priceMonthly / 30 +
                                    (props.announce.priceMonthly / 30) *
                                        (percentage / 100)
                                ).toFixed(2);
                                setTarif(ETarifs.MENSUEL);
                            } else {
                                normalPrice = (
                                    props.announce.price +
                                    props.announce.price * (percentage / 100)
                                ).toFixed(2);
                                setTarif(ETarifs.JOURNALIER);
                            }
                            if (props.announce.promotion) {
                                // const normalPriceSimple=(props.announce.price +(props.announce.price * (percentage/100))).toFixed(2)
                                normalPriceProm = (
                                    props.announce.promotion.price +
                                    props.announce.promotion.price *
                                        (percentage / 100)
                                ).toFixed(2);
                                normalPriceWithDaysProm = (
                                    nbJourProm * Number(normalPriceProm)
                                ).toFixed(2); /*change*/
                                normalPriceWithDaysSimple = (
                                    nbJourSimple * Number(normalPrice)
                                ).toFixed(2); /*change*/
                                normalPriceWithDaysWithCleaningFeesProm =
                                    Number(normalPriceWithDaysSimple) +
                                    Number(normalPriceWithDaysProm) +
                                    (props.announce.cleaningFees +
                                        props.announce.cleaningFees *
                                            (percentage / 100)) +
                                    getTotalFraiService();
                            }
                            ConvertedDeviseWithMoneySign(
                                props.announce.devise || "XAF",
                                currency,
                                Number(normalPriceProm)
                            )
                                .then((value: any): any =>
                                    setPriceConvertedProm(value)
                                )
                                .catch((error) => console.log(error));

                            ConvertedDeviseWithMoneySign(
                                props.announce.devise || "XAF",
                                currency,
                                Number(normalPriceWithDaysSimple)
                            )
                                .then((value: any): any =>
                                    setPriceConvertedSimple(value)
                                )
                                .catch((error) =>
                                    console.log(error)
                                ); /*change*/

                            ConvertedDeviseWithMoneySign(
                                props.announce.devise || "XAF",
                                currency,
                                Number(normalPriceWithDaysProm)
                            )
                                .then((value: any): any =>
                                    setDayPriceProm(value)
                                )
                                .catch((error) => console.log(error));

                            ConvertedDeviseWithMoneySign(
                                props.announce.devise || "XAF",
                                currency,
                                Number(normalPriceWithDaysWithCleaningFeesProm)
                            )
                                .then((value: any): any =>
                                    setTotalPriceProm(value)
                                )
                                .catch((error) => console.log(error));

                            ConvertedDeviseWithMoneySign(
                                props.announce.devise || "XAF",
                                currency,
                                Number(normalPrice)
                            )
                                .then((value: any): any =>
                                    setPriceConverted(value)
                                )
                                .catch((error) => console.log(error));

                            const normalPriceWithDays = (
                                getDayNumber(
                                    reservation.dateCheckIn,
                                    reservation.dateCheckOut
                                ) * Number(normalPrice)
                            ).toFixed(2);
                            ConvertedDeviseWithMoneySign(
                                props.announce.devise || "XAF",
                                currency,
                                Number(normalPriceWithDays)
                            )
                                .then((value: any): any => setDayPrice(value))
                                .catch((error) => console.log(error));

                            ConvertedDeviseWithMoneySign(
                                props.announce.devise || "XAF",
                                currency,
                                props.announce.cleaningFees +
                                    props.announce.cleaningFees *
                                        (percentage / 100)
                            )
                                .then((value: any): any =>
                                    setCleaningFee(value)
                                )
                                .catch((error) => console.log(error));

                            const normalPriceWithDaysWithCleaningFees =
                                Number(normalPriceWithDays) +
                                (props.announce.cleaningFees +
                                    props.announce.cleaningFees *
                                        (percentage / 100)) +
                                getTotalFraiService();
                            // console.log(
                            //     "ty no ilaina ",
                            //     normalPriceWithDaysWithCleaningFees
                            // );

                            ConvertedDeviseWithoutMoneySign(
                                props.announce.devise,
                                "XAF",
                                Number(normalPriceWithDaysWithCleaningFees)
                            )
                                .then((value) => {
                                    props.setTotalPaye(Number(value));
                                    const priceWithCredit =
                                        Number(value) -
                                        (props.paidByCredit ?? 0);
                                        ConvertedDeviseWithoutMoneySign(
                                            props.announce.devise,
                                            "XAF",
                                            Number(normalPriceWithDaysWithCleaningFees)
                                        )
                                        .then((value) => {
                                            props.setTotalPaye(Number(value));
                                            const priceWithCredit = Number(value) - (props.paidByCredit ?? 0);
                                            
                                            // Calculate payments based on percentage
                                            const numericAdvance = (priceWithCredit * ADVANCE_PAYMENT_PERCENTAGE) / 100;
                                            const numericBalance = priceWithCredit - numericAdvance;
                                            
                                            setTotalPrice(priceWithCredit);
                                            setAdvancePayment(numericAdvance);
                                            setBalancePayment(numericBalance);
                                            
                                            // Get formatted versions
                                            ConvertedDeviseWithMoneySign("XAF", currency, priceWithCredit)
                                                .then(setTotalPriceFormatted)
                                                .catch(console.error);
                                            
                                            ConvertedDeviseWithMoneySign("XAF", currency, numericAdvance)
                                                .then(setAdvancePaymentFormatted)
                                                .catch(console.error);
                                                
                                            ConvertedDeviseWithMoneySign("XAF", currency, numericBalance)
                                                .then(setBalancePaymentFormatted)
                                                .catch(console.error);
                                        })
                                        .catch(console.error);
                                })
                                .catch((error) => console.log(error));

                            if (props.paidByCredit && props.paidByCredit > 0)
                                ConvertedDeviseWithMoneySign(
                                    "XAF",
                                    currency,
                                    props.paidByCredit
                                )
                                    .then((value: any): any =>
                                        setPaidByCreditConverted(value)
                                    )
                                    .catch((error) => console.log(error));
                        }
                    }
                });
        }
    }, [
        currency,
        reservation,
        props.userServices,
        nbJourSimple,
        nbJourProm,
        nbJours,
        props.paidByCredit,
    ]);

    const previewPhotos = props.announce.property.photos.map((photo: any) => {
        if (photo.fileURL) {
            return {
                id: photo._id,
                url: `${Env.ApiRoot}/images/properties/${photo.filename}`,
                filename: photo.filename,
            };
        }
        return {
            id: photo._id,
            url: "",
        };
    });

    type CreditApplicationResult = {
        adjustedTotal: number;
        creditUsed: number;
        isFullyCovered: boolean;
      };

    const applyCreditToTotal = (totalPrice: number): CreditApplicationResult => {
       const credit = props.paidByCredit ?? 0;
        
        // Return object with both adjusted total and credit used
        return {
          adjustedTotal: Math.max(0, totalPrice - credit),
          creditUsed: Math.min(credit, totalPrice),
          isFullyCovered: credit >= totalPrice
        };
      };


    const [t] = useTranslation();
    const classes = useStyles();

    //Date managin
    const handleClickEditDate = () => {
        setIsUpdatingDates(true);
    };

    const handleClickCancelEditDate = () => {
        setReservation(oldReservationValue);
        query.set(
            "dci",
            oldReservationValue.dateCheckIn.toString().replace(/\/+/g, "-")
        );
        query.set(
            "dco",
            oldReservationValue.dateCheckOut.toString().replace(/\/+/g, "-")
        );
        history.push({ search: query.toString() });
        props.setUpdatePaymentData(false);
    };
    const handleClickSaveDate = () => {
        props.setUpdatePaymentData(true);
        setIsUpdatingDates(false);
    };

    const onChangeDateValue = (n: string, d: string) => {
        if (n === "dci") {
            setReservation({
                ...reservation,
                dateCheckIn: d,
            });
        } else if (n === "dco") {
            setReservation({
                ...reservation,
                dateCheckOut: d,
            });
        } else {
            setReservation({
                ...reservation,
                [n]: d,
            });
        }
        query.set(n, d.replace(/\/+/g, "-"));
        history.push({ search: query.toString() });

        // Force update of credit calculation
        if (props.paidByCredit && props.paidByCredit > 0) {
            ConvertedDeviseWithMoneySign(
                "XAF",
                currency,
                props.paidByCredit
            )
            .then((value: string) => {
                // Convert the string value to a number before setting state
                const numericValue = parseFloat(value.replace(currency.toUpperCase(), ""));
                setPaidByCreditConverted(numericValue);
            })
            .catch(console.error);
        }
    };

    //Traveler managing
    const handleClickEditTraveller = () => {
        setIsUpdatingTraveller(true);
    };

    const handleClickCancelEditTraveller = () => {
        setReservation(oldReservationValue);
        query.set(
            "travellerAdultTotal",
            oldReservationValue.travellerAdultTotal.toString()
        );
        query.set(
            "travellerChildTotal",
            oldReservationValue.travellerChildTotal.toString()
        );
        history.push({ search: query.toString() });
        props.setUpdatePaymentData(true);
        setIsUpdatingTraveller(false);
    };

    const handleClickSaveTraveller = () => {
        props.setUpdatePaymentData(true);
        setIsUpdatingTraveller(false);
    };

    const onChangeTravellerValue = (n: string, v: number) => {
        query.set(n, v.toString());
        history.push({ search: query.toString() });
        if (v < 0 || v > props.announce.property.maximumGuests) return;
        setReservation({
            ...reservation,
            [n]: v,
        });
    };

    const getTotalFraiService = (): number => {
        let totalService = 0;
        if (props.selectedServices.length > 0) {
            props.selectedServices.forEach((val) => {
                props.userServices.forEach((userService: IUserService) => {
                    if (userService._id === val) {
                        totalService += userService.price;
                    }
                });
            });
        }

        return totalService;
    };

    const useFormattedDuration = () => {
        const { t } = useTranslation(); // ✅ Hook is now inside a valid custom hook
    
        return (values: DurationValues) => {
            const { trs_duration_days, trs_duration_hours, trs_duration_minutes } = values;
    
            const parts: string[] = [];
            if (trs_duration_days > 0) parts.push(`${trs_duration_days} ${t('propriete.units.day', { count: trs_duration_days })}`);
            if (trs_duration_hours > 0) parts.push(`${trs_duration_hours} ${t('propriete.units.hour', { count: trs_duration_hours })}`);
            if (trs_duration_minutes > 0) parts.push(`${trs_duration_minutes} ${t('propriete.units.minute', { count: trs_duration_minutes })}`);
    
            return parts.length ? parts.join(", ") : t('propriete.labels.no_duration_specified');
        };
    };
    
    const formatDuration = useFormattedDuration();

    const getTypographyContent = (searchType: any) => {
            // Determine the correct field for language
            const langSuffix = i18n.language === "fr" ? "nomFR" : "nomEN";
        
            const getCityName = () =>
                props.announce.property.address.city?.[langSuffix] || "Unknown City";
            const getCountryName = () =>
                props.announce.property.address.country?.[langSuffix] || "Unknown Country";
        
            switch (searchType) {
                case "apts":
                    return (
                        <Typography>
                            {props.announce.property.address.quartier ? (
                                <span >
                                    {props.announce.property.address.quartier}
                                </span>
                            ) : (
                                <span>N/A</span>
                            )}
                            {", "}
                            <span >
                                {getCityName()}
                            </span>
                            {" | "}
                            <span>
                                {props.announce.property.maximumGuests === 1
                                    ? `${props.announce.property.maximumGuests} ${t("announceGuest")} Maximum`
                                    : `${props.announce.property.maximumGuests} ${t("announceGuests")} Maximum`}
                            </span>
                            {" | "}
                            <span>
                            {Number(props.announce.property.rooms) === 1
                                ? `${props.announce.property.rooms} ${t("announceRoom")}`
                                : `${props.announce.property.rooms} ${t("announceRooms")}`}
                            </span>
                            {" | "}
                            <span>
                                {props.announce.property.bathrooms === 1
                                    ? `${props.announce.property.bathrooms} ${t("announceBathroom")}`
                                    : `${props.announce.property.bathrooms} ${t("announceBathrooms")}`}
                            </span>
                        </Typography>
                    );
                case "htls":
                    return (
                        <Typography>
                            {props.announce.property.address.quartier ? (
                                <span >
                                    {props.announce.property.address.quartier}
                                </span>
                            ) : (
                                <span>N/A</span>
                            )}
                            {", "}
                            <span >
                                {getCityName()}
                            </span>
                            {" | "}
                            <span>
                                {props.announce.property.maximumGuests === 1
                                    ? `${props.announce.property.maximumGuests} ${t("announceGuest")} Maximum`
                                    : `${props.announce.property.maximumGuests} ${t("announceGuests")} Maximum`}
                            </span>
                            {" | "}
                            <span>
                            {Number(props.announce.property.rooms) === 1
                                ? `${props.announce.property.rooms} ${t("announceRoom")}`
                                : `${props.announce.property.rooms} ${t("announceRooms")}`}
                            </span>
                            {" | "}
                            <span>
                                {props.announce.property.bathrooms === 1
                                    ? `${props.announce.property.bathrooms} ${t("announceBathroom")}`
                                    : `${props.announce.property.bathrooms} ${t("announceBathrooms")}`}
                            </span>
                        </Typography>
                    );
                case "cars":
                    return (
                        <Typography>
                            <span>{getCityName()}</span>
                            {" | "}
                            <span>{getCountryName()}</span>
                            {" | "}
                            <span>
                                {props.announce.property.vhcl_passengers === 1
                                    ? `${props.announce.property.vhcl_passengers} ${t("label.passager")} Maximum`
                                    : `${props.announce.property.vhcl_passengers} ${t("label.passagers")} Maximum`}
                            </span>
                            {" | "}
                            <span>
                                {props.announce.property.vhcl_bags === 1
                                    ? `${props.announce.property.vhcl_bags} ${t("label.baggage")}`
                                    : `${props.announce.property.vhcl_bags} ${t("label.baggages")}`}
                            </span>
                            {" | "}
                            <span>
                                {props.announce.property.vhcl_doors === 1
                                    ? `${props.announce.property.vhcl_doors} ${t("label.porte")}`
                                    : `${props.announce.property.vhcl_doors} ${t("label.portes")}`}
                            </span>
                            {" | "}
                            <span>
                                {props.announce.property.vhcl_fuelType
                                    ? props.announce.property.vhcl_fuelType.charAt(0).toUpperCase() +
                                    props.announce.property.vhcl_fuelType.slice(1)
                                    : ""}
                            </span>
                        </Typography>
                    );
                case "evts":
                    return (
                        <Typography>
                            <span>{props.announce.property.address.name || "Unknown Event"}</span>
                            {" | "}
                            <span>{getCountryName()}</span>
                            {" | Date: "}
                            {props.announce.property.eventDate || "TBA"}
                        </Typography>
                    );
                case "trs":
                    return (
                        <Typography>    
                            {/* Display duration if available */}
                            {(props.announce?.property?.trs_duration_days || props.announce?.property?.trs_duration_hours || props.announce?.property?.trs_duration_minutes) && (
                                <div style={{ marginTop: '4px' }}>
                                    <span>
                                        {formatDuration({
                                            trs_duration_days: Number(props.announce.property.trs_duration_days) || 0,
                                            trs_duration_hours: Number(props.announce.property.trs_duration_hours) || 0,
                                            trs_duration_minutes: Number(props.announce.property.trs_duration_minutes) || 0,
                                        })}
                                    </span>
                                    <span>&nbsp;|&nbsp;</span>
                                    <span>{props.announce?.property?.trs_frequency}</span>
                                </div>
                            )}

                            <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                overflow: 'hidden', // Ensures content doesn't overflow
                                whiteSpace: 'nowrap', // Prevents text from wrapping
                                textOverflow: 'ellipsis', // Adds ellipsis at the end
                                maxWidth: '100%', // Adjust this value as needed
                            }}>
                                <span style={{ marginLeft: '8px', marginRight: '8px' }}>&nbsp;|&nbsp;</span> {/* Use &nbsp; for non-breaking spaces */}

                                {props.announce.property.address.quartier ? (
                                    <span>{props.announce.property.address.quartier}</span>
                                ) : (
                                    <span>N/A</span>
                                )}

                                <span>&nbsp;·&nbsp;</span> {/* Use &nbsp; for non-breaking spaces */}

                                <span>{getCityName()}</span>                     
                            </div>
                        </Typography>
                    );
                case "rstt":
                    return (
                        <Typography>
                            <a 
                                href={`/search?search_pays=${props.announce.property.address.country._id}&search_adresse=${props.announce.property.address.city._id}&quartier=&offer=0&price=&priceMin=&currencyBase=XAF&currency=xaf&refreshData=1&travellerChildTotal=0&travellerAdultTotal=2&type=${props.announce.property.type.searchType.name}&page=1&dci=&dco=&eqt=&click=${props.announce.property.type.name}&rooms=&luxury=false&perle=false&business=false`}
                                style={{ textDecoration: 'underline', color: 'inherit' }}
                                target="_blank"
                                rel="noopener noreferrer"
                                >
                                {getCityName()}
                            </a>
                            {" | "}
                            <span>{getCountryName()}</span>
                        </Typography>
                    );
                default:
                    return null;
            }
        };

        const language = i18n.language;
        const propertyName = props.announce.property.name;
        const propertyType = props.announce.property.type.name;
        const cityFR = props.announce.property?.address?.city?.nomFR;
        const cityEN = props.announce.property?.address?.city?.nomEN;
        const quartier = props.announce.property?.address?.quartier;
        

        let message = '';

        if (language === 'fr') {
        message = `Bonjour, je suis sur le point de finaliser une réservation sur AfriqPnB pour l'annonce "${propertyType}: ${propertyName}" à ${quartier}, ${cityFR}. J’ai quelques questions avant de confirmer. Pouvez-vous m’aider ?`;
        } else {
        message = `Hello, I'm about to complete a booking on AfriqPnB for the listing "${propertyType}: ${propertyName}" in ${quartier}, ${cityEN}. I have a few questions before confirming. Could you please assist me?`;
        }
        const whatsappUrl = `https://wa.me/237699982782?text=${encodeURIComponent(message)}`;
        

        const totalNbrOfDays = props.announce.promotion 
            ? Number(nbJourSimple) + Number(nbJourProm) 
            : getDayNumber(reservation.dateCheckIn, reservation.dateCheckOut);

    return (
        <div className={classes.root}>
            <Paper elevation={2} style={{ padding: 24 }}>
                <Grid container direction="column">
                    {reservation.dateCheckIn && reservation.dateCheckOut ? (
                        <>
                            <Grid item container direction="row" spacing={2}>
                                {/*<Grid item>
                                <div style = {{justifyContent: 'center', color: '#890806', marginBottom: 20}}>
                                    <Typography style={{ fontSize: '22px'}}>
                                        {t("label.recapitulatif-de-votre-reservation")}
                                    </Typography>
                                </div>
                                </Grid> */}
                                
                                <Grid item className={classes.previewPhotos}>
                                    <PreviewPhotosReservation
                                        photos={previewPhotos}
                                        isUpdating={false}
                                        idProperty=""
                                    />
                                </Grid> 
                                <Grid item>
                                    <Grid item>
                                        <Typography style = {{fontSize: '20px', fontWeight: 'bold'}}>
                                            {props.announce.property.name}
                                        </Typography>
                                        <Typography style={{ fontSize: '16px' }}>
                                                {getTypographyContent(searchType)}
                                        </Typography>

                                        {/*<Typography style={{ fontSize: '16px' }}>
                                            {`${props.announce.property.address.quartier}, ${
                                            i18n.language === 'fr'
                                                ? props.announce.property.address.city.nomFR
                                                : props.announce.property.address.city.nomEN
                                            }, ${
                                            i18n.language === 'fr'
                                                ? props.announce.property.address.country.nomFR
                                                : props.announce.property.address.country.nomEN
                                            }`}
                                        </Typography>*/}
                                    </Grid>
                                    {/*<Grid item>
                                        <div
                                            className={classes.simpleText}
                                            dangerouslySetInnerHTML={createMarkup(
                                                props.announce.description.substring(
                                                    0,
                                                    150
                                                ) as string
                                            )}
                                        ></div>
                                        <br />
                                    </Grid>*/}
                                </Grid>
                            </Grid>
                            <p>
                                <Divider />
                            </p>
                            <Grid item>     
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    style = {{fontSize: '16px'}}
                                >
                                    <Grid>
                                        <p style={{ fontSize: '18px', fontWeight: 'bold' }}>{t("reservation.datesTitle")}</p>
                                        <p style={{ fontSize: '16px', marginBottom: 4 }}>
                                            {`${moment(reservation.dateCheckIn).format('ddd D MMM YYYY')}   ->    ${moment(reservation.dateCheckOut).format('ddd D MMM YYYY')}`}
                                        </p>
                                        <p>
                                                {" "}{totalNbrOfDays}{" "}{t( "label.nuits" )}
                                        </p>                                                                                           
                                                                                    
                                        {!isUpdatingDates && (
                                            <p
                                                onClick={handleClickEditDate}
                                                style={{
                                                    fontSize: '14px',
                                                    color: '#890608',
                                                    textDecoration: 'underline',
                                                    cursor: 'pointer',
                                                    marginTop: 10,
                                                }}
                                            >
                                                {t("reservation.changeDates")}
                                            </p>
                                        )}
                                    </Grid>

                                    {isUpdatingDates && (
                                        <Grid>
                                            <Button onClick={handleClickCancelEditDate}>
                                                <CancelIcon /> {t("propriete.buttonCancel")}
                                            </Button>
                                            <Button onClick={handleClickSaveDate}>
                                                <SaveIcon /> {t("propriete.buttonSave")}
                                            </Button>
                                        </Grid>
                                    )}
                                </Grid>
                                {isUpdatingDates && (
                                    <>
                                        <Grid container>
                                            <PnBDateRange
                                                dci={
                                                    reservation.dateCheckIn
                                                }
                                                dco={
                                                    reservation.dateCheckOut
                                                }
                                                changeValue={
                                                    onChangeDateValue
                                                }
                                            />
                                        </Grid>
                                    </>
                                )}

                                <p> <Divider /> </p>
                               
                                {/*}
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    style = {{fontSize: 16, marginBottom: 30}}                                    
                                >
                                    <Grid>
                                        <p style={{ fontSize: '16px', fontWeight: 'bold'}} >{t("label.voyageurs")}</p>
                                        <p style={{ fontSize: '16px'}} >
                                            {reservation.travellerAdultTotal +
                                                reservation.travellerChildTotal}{" "}
                                            {t("home.voyaguers")}
                                        </p>
                                    </Grid>
                                    <Grid>
                                        <Button
                                            onClick={
                                                isUpdatingTraveller
                                                    ? handleClickCancelEditTraveller
                                                    : handleClickEditTraveller
                                            }
                                        >
                                            {isUpdatingTraveller ? (
                                                <>
                                                    <CancelIcon />{" "}
                                                    {t(
                                                        "propriete.buttonCancel"
                                                    )}{" "}
                                                </>
                                            ) : (
                                                <>
                                                    <EditOutlined />{" "}
                                                    {t("contextMenu.editer")}{" "}
                                                </>
                                            )}
                                        </Button>
                                        {isUpdatingTraveller && (
                                            <Button
                                                onClick={
                                                    handleClickSaveTraveller
                                                }
                                            >
                                                <SaveIcon />{" "}
                                                {t("propriete.buttonSave")}
                                            </Button>
                                        )}
                                    </Grid>
                                    {isUpdatingTraveller && (
                                        <>
                                            <Grid >
                                                <p>
                                                    <PnbQtePicker
                                                        name="travellerAdultTotal"
                                                        label={t(
                                                            "label.adultes"
                                                        )}
                                                        value={
                                                            reservation.travellerAdultTotal
                                                        }
                                                        valueTotal={
                                                            reservation.travellerAdultTotal +
                                                            reservation.travellerChildTotal
                                                        }
                                                        annonce={props.announce}
                                                        onValueChange={
                                                            onChangeTravellerValue
                                                        }
                                                    />
                                                </p>
                                            </Grid>
                                            <Grid>
                                                <p>
                                                    <PnbQtePicker
                                                        name="travellerChildTotal"
                                                        label={t(
                                                            "label.enfants"
                                                        )}
                                                        value={
                                                            reservation.travellerChildTotal
                                                        }
                                                        valueTotal={
                                                            reservation.travellerAdultTotal +
                                                            reservation.travellerChildTotal
                                                        }
                                                        annonce={props.announce}
                                                        onValueChange={
                                                            onChangeTravellerValue
                                                        }
                                                    />
                                                </p>
                                            </Grid>
                                        </>
                                    )}
                                </Grid> */}
                                <>
                                    {!props.cond ? (
                                        props.announce.promotion ? (
                                            <div style = {{marginTop: 30}}>
                                                <Typography style = {{fontSize: '16px', fontWeight: 'bold'}}>
                                                    {t("label.détail-du-prix")}
                                                </Typography>
                                                {isNaN(
                                                    parseInt(
                                                        priceConverted
                                                            .toString()
                                                            .replace(
                                                                currency.toUpperCase(),
                                                                ""
                                                            )
                                                    )
                                                ) ||
                                                priceConverted === 0 ||
                                                isNaN(
                                                    parseInt(
                                                        priceConvertedProm
                                                            .toString()
                                                            .replace(
                                                                currency.toUpperCase(),
                                                                ""
                                                            )
                                                    )
                                                ) ||
                                                priceConvertedProm === 0 ||
                                                priceConvertedSimple === 0 ? (
                                                    <>
                                                        <CircularProgress
                                                            size={16}
                                                            style={{
                                                                color: "#890608",
                                                            }}
                                                        />{" "}
                                                    </>
                                                ) : (
                                                    <>
                                                        {nbJourSimple > 0 ? (
                                                            <>
                                                                <Grid container>
                                                                    <Grid style = {{fontSize: '16px'}}>
                                                                        {/* <p className="text_body"> */}
                                                                        {getTarifLabel(
                                                                            tarif
                                                                        )}
                                                                        {/* </p>        */}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid
                                                                    container
                                                                    direction="row"
                                                                    justifyContent="space-between"
                                                                    style={{
                                                                        marginBottom:
                                                                            -12,
                                                                        fontSize: 16
                                                                    }}
                                                                >
                                                                    <Grid>
                                                                        <p style = {{fontSize: '16px'}}>
                                                                            {
                                                                                <>
                                                                                    {
                                                                                        priceConverted
                                                                                    }{" "}
                                                                                    x{" "}
                                                                                    {
                                                                                        nbJourSimple
                                                                                    }{" "}
                                                                                    {t(
                                                                                        "label.nuits"
                                                                                    )}
                                                                                </>
                                                                            }
                                                                        </p>
                                                                    </Grid>
                                                                    <Grid>
                                                                        <p style = {{fontSize: '16px', fontWeight: 'bold'}} >
                                                                            {
                                                                                priceConvertedSimple
                                                                            }
                                                                        </p>
                                                                    </Grid>
                                                                </Grid>
                                                            </>
                                                        ) : (
                                                            ""
                                                        )}
                                                        <Grid
                                                            container
                                                            direction="row"
                                                            justifyContent="space-between"
                                                            style={{
                                                                marginBottom:
                                                                    -12,
                                                                    fontSize: 16
                                                            }}
                                                        >
                                                            {nbJourProm > 0 ? (
                                                                <>
                                                                    <Grid>
                                                                        <p style = {{fontSize: '16px'}}>
                                                                            {
                                                                                <>
                                                                                    {
                                                                                        priceConvertedProm
                                                                                    }{" "}
                                                                                    x{" "}
                                                                                    {
                                                                                        nbJourProm
                                                                                    }{" "}
                                                                                    {t(
                                                                                        "label.nuits"
                                                                                    )}
                                                                                </>
                                                                            }
                                                                        </p>
                                                                    </Grid>
                                                                    <Grid>
                                                                        <p style = {{fontSize: '16px', fontWeight: 'bold'}}>
                                                                            {
                                                                                DayPriceProm
                                                                            }
                                                                        </p>
                                                                    </Grid>
                                                                </>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </Grid>
                                                    </>
                                                )}
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="space-between"
                                                    style={{
                                                        marginBottom: -12,
                                                        fontSize: 16
                                                    }}
                                                >
                                                    <Grid>
                                                        <p style = {{fontSize: '16px'}}>
                                                            {t(
                                                                "label.frais-de-nettoyage"
                                                            )}
                                                        </p>
                                                    </Grid>
                                                    <Grid>
                                                        <p style = {{fontSize: '16px', fontWeight: 'bold'}}>
                                                            {cleaningFee}
                                                        </p>
                                                    </Grid>
                                                </Grid>
                                                {props.userServices.length >
                                                    0 && (
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        justifyContent="space-between"
                                                        style = {{fontSize: '16px'}}
                                                    >
                                                        <Grid>
                                                            <p style = {{fontSize: '16px'}}>
                                                                {t(
                                                                    "label.frais-de-service"
                                                                )}
                                                            </p>
                                                        </Grid>
                                                        <Grid>
                                                            <p style = {{fontSize: '16px', fontWeight: 'bold'}}>
                                                                {
                                                                    servicePriceAppli
                                                                }{" "}
                                                                {currency}{" "}
                                                            </p>
                                                        </Grid>
                                                    </Grid>
                                                )}
                                                {props.paidByCredit &&
                                                props.paidByCredit > 0 ? (
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        justifyContent="space-between"
                                                        style={{
                                                            fontSize: 16
                                                        }}

                                                    >
                                                        <Grid>
                                                            <p style = {{fontSize: '16px'}}>
                                                                {t(
                                                                    "label.paye-par-credit"
                                                                )}
                                                            </p>
                                                        </Grid>
                                                        <Grid>
                                                            <p style = {{fontSize: '16px', fontWeight: 'bold'}}>
                                                                -{" "}
                                                                {
                                                                    paidByCreditConverted
                                                                }
                                                            </p>
                                                        </Grid>
                                                    </Grid>
                                                ) : null}
                                                {isNaN(
                                                    parseInt(
                                                        priceConverted
                                                            .toString()
                                                            .replace(
                                                                currency.toUpperCase(),
                                                                ""
                                                            )
                                                    )
                                                ) ||
                                                priceConverted === 0 ||
                                                isNaN(
                                                    parseInt(
                                                        priceConvertedProm
                                                            .toString()
                                                            .replace(
                                                                currency.toUpperCase(),
                                                                ""
                                                            )
                                                    )
                                                ) ||
                                                priceConvertedProm === 0 ||
                                                totalPriceProm === 0 ? (
                                                    <>
                                                        <CircularProgress
                                                            size={16}
                                                            style={{
                                                                color: "#890608",
                                                            }}
                                                        />{" "}
                                                    </>
                                                ) : (
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        justifyContent="space-between"
                                                        style={{
                                                            fontSize: 16,
                                                            color: '#890608',
                                                            marginTop: 10
                                                        }}

                                                    >
                                                        <Grid>
                                                            <div style = {{fontSize: '16px', fontWeight: 'bold'}}>
                                                                <p>Total</p>
                                                            </div>
                                                        </Grid>
                                                        <Grid>
                                                            <div style = {{fontSize: '16px', fontWeight: 'bold'}}>
                                                                <p>
                                                                    {
                                                                        totalPriceProm
                                                                    }
                                                                </p>
                                                            </div>
                                                        </Grid>
                                                    </Grid>
                                                )}
                                            </div>
                                        ) : (
                                            <>
                                                <Typography style = {{fontSize: '18px', fontWeight: 'bold', marginTop: 10}}>
                                                    {t("label.détail-du-prix")}
                                                </Typography>
                                                {isNaN(
                                                    parseInt(
                                                        priceConverted
                                                            .toString()
                                                            .replace(
                                                                currency.toUpperCase(),
                                                                ""
                                                            )
                                                    )
                                                ) ||
                                                priceConverted === 0 ||
                                                isNaN(
                                                    parseInt(
                                                        servicePriceAppli
                                                            .toString()
                                                            .replace(
                                                                currency.toUpperCase(),
                                                                ""
                                                            )
                                                    )
                                                ) ||
                                                servicePriceAppli === 0 ||
                                                totalPrice === 0 ? (
                                                    <>
                                                        <CircularProgress
                                                            size={16}
                                                            style={{
                                                                color: "#890608",
                                                            }}
                                                        />{" "}
                                                    </>
                                                ) : (
                                                    <>
                                                        <Grid
                                                            container
                                                            direction="row"
                                                            justifyContent="space-between"
                                                            style={{
                                                                marginBottom:
                                                                    -12,
                                                                    fontSize: 16
                                                            }}
    
                                                        >
                                                            <Grid>
                                                                <p style = {{fontSize: '16px'}}>
                                                                    {
                                                                        <>
                                                                            {
                                                                                priceConverted
                                                                            }{" "}
                                                                            x{" "}
                                                                            {getDayNumber(
                                                                                reservation.dateCheckIn,
                                                                                reservation.dateCheckOut
                                                                            )}{" "}
                                                                            {t(
                                                                                "label.nuits"
                                                                            )}
                                                                        </>
                                                                    }
                                                                </p>
                                                            </Grid>
                                                            <Grid>
                                                                <p style = {{fontSize: '16px', fontWeight: 'bold'}}>
                                                                    {DayPrice}
                                                                </p>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid
                                                            container
                                                            direction="row"
                                                            justifyContent="space-between"
                                                            style={{
                                                                marginBottom:
                                                                    -12,
                                                                    fontSize: 16
                                                            }}
                                                        >
                                                            <Grid>
                                                                <p style = {{fontSize: '16px'}}>
                                                                    {t(
                                                                        "label.frais-de-nettoyage"
                                                                    )}
                                                                </p>
                                                            </Grid>
                                                            <Grid>
                                                                <p style = {{fontSize: '16px', fontWeight: 'bold'}}>
                                                                    {
                                                                        cleaningFee
                                                                    }
                                                                </p>
                                                            </Grid>
                                                        </Grid>
                                                        {props.userServices
                                                            .length > 0 && (
                                                            <Grid
                                                                container
                                                                direction="row"
                                                                justifyContent="space-between"
                                                                style={{
                                                                        fontSize: 16
                                                                }}
                                                            >
                                                                <Grid>
                                                                    <p style = {{fontSize: '16px'}}>
                                                                        {t(
                                                                            "label.frais-de-service"
                                                                        )}
                                                                    </p>
                                                                </Grid>
                                                                <Grid>
                                                                    <p style = {{fontSize: '16px', fontWeight: 'bold'}}>
                                                                        {
                                                                            servicePriceAppli
                                                                        }{" "}
                                                                        {currency.toLocaleUpperCase()}
                                                                    </p>
                                                                </Grid>
                                                            </Grid>
                                                        )}
                                                        {props.paidByCredit &&
                                                        props.paidByCredit >
                                                            0 ? (
                                                            <Grid
                                                                container
                                                                direction="row"
                                                                justifyContent="space-between"
                                                                style={{
                                                                        fontSize: 16
                                                                }}
                                                            >
                                                                <Grid>
                                                                    <p style = {{fontSize: '16px'}}>
                                                                        {t(
                                                                            "label.paye-par-credit"
                                                                        )}
                                                                    </p>
                                                                </Grid>
                                                                <Grid>
                                                                    <p style = {{fontSize: '16px', fontWeight: 'bold'}}>
                                                                        -{" "}
                                                                        {
                                                                            paidByCreditConverted
                                                                        }
                                                                    </p>
                                                                </Grid>
                                                            </Grid>
                                                        ) : null}
                                                        <Grid
                                                            container
                                                            direction="row"
                                                            justifyContent="space-between"
                                                            style={{
                                                                    fontSize: 16,
                                                                    color: '#890608',
                                                                    marginBottom: 15,
                                                                    marginTop: 10
                                                            }}
                                                        >
                                                            <Grid>
                                                                <div style = {{fontSize: '16px', fontWeight: 'bold'}}>
                                                                    <p>Total</p>
                                                                </div>
                                                            </Grid>
                                                            <Grid>
                                                                <div style = {{fontSize: '16px', fontWeight: 'bold'}}>
                                                                    <p>
                                                                        {
                                                                            totalPriceFormatted
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </Grid>
                                                        </Grid>

                                                        <p>
                                                            <Divider />
                                                        </p>

                                                        {/* Payment Summary Section */}
                                                        <Grid item style={{ marginBottom: 15, marginTop: 15 }}>
                                                        {console.log('Payment Comparison:', {
                                                            totalPrice,
                                                            paidByCredit: props.paidByCredit,
                                                            comparison: totalPrice <= (props.paidByCredit ?? 0)
                                                        })}
                                                        
                                                        {Number(totalPrice) <= Number(props.paidByCredit ?? 0) ? (
                                                            // Full credit coverage case
                                                            <>
                                                                <Typography style={{ fontSize: '18px', fontWeight: 'bold', color: '#4CAF50' }}>
                                                                {t("label.full-credit-coverage")}
                                                                </Typography>
                                                                <Grid container direction="row" justifyContent="space-between">
                                                                <Typography>{t("label.total-booking-cost")}:</Typography>
                                                                <Typography>{totalPriceFormatted}</Typography>
                                                                </Grid>
                                                                <Grid container direction="row" justifyContent="space-between">
                                                                <Typography>{t("label.credit-applied")}:</Typography>
                                                                <Typography>- {paidByCreditConverted}</Typography>
                                                                </Grid>
                                                                <Grid container direction="row" justifyContent="space-between" style={{ fontWeight: 'bold' }}>
                                                                <Typography>{t("label.amount-due-now")}:</Typography>
                                                                <Typography>{ConvertedDeviseWithMoneySign("XAF", currency, 0)}</Typography>
                                                                </Grid>
                                                            </>
                                                        ) : (
                                                            // Partial credit or no credit case
                                                            <>
                                                                <Typography style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                                    {t("label.payment-required-for-confirmation")}
                                                                </Typography>
                                                                <Typography variant="caption" style={{ fontStyle: 'italic' }}>
                                                                    {t("label.advance-payment-explanation", { percentage: ADVANCE_PAYMENT_PERCENTAGE })}
                                                                </Typography>
                                                                
                                                                <Grid container direction="row" justifyContent="space-between" style={{ marginTop: 16 }}>
                                                                    <Typography style={{ fontSize: '16px', fontWeight: 'bold' , color: '#890608'  }}>
                                                                    {t("label.advance-payment", { percentage: ADVANCE_PAYMENT_PERCENTAGE })}    
                                                                    </Typography>
                                                                    <Typography style={{ fontSize: '16px', fontWeight: 'bold', color: '#890608' }}>
                                                                    {advancePaymentFormatted || (
                                                                        <CircularProgress size={16} style={{ color: "#890608" }} />
                                                                    )}
                                                                    </Typography>
                                                                </Grid>
                                                                
                                                                <Grid container direction="row" justifyContent="space-between" style={{ marginTop: 8 }}>
                                                                    <Typography style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                                    {t("label.balance-due-on-site")}
                                                                    </Typography>
                                                                    <Typography style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                                    {balancePaymentFormatted || (
                                                                        <CircularProgress size={16} style={{ color: "#890608" }} />
                                                                    )}
                                                                    </Typography>
                                                                </Grid>
                                                                
                                                            </>
                                                        )}
                                                        </Grid>

                                                    <Divider style={{ margin: '16px 0' }} />

                                                    {/* Customer Service Section - Always shown */}
                                                    <Grid item style={{ marginTop: 16 }}>
                                                    <Typography style={{ fontSize: '16px' }}>
                                                        <Trans
                                                        i18nKey="label.contact-customer-service"
                                                        components={{
                                                            1: (
                                                            <a
                                                                href={whatsappUrl}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ textDecoration: "underline", fontWeight: "bold", color: "#890608" }}
                                                            />
                                                            )
                                                        }}
                                                        />
                                                    </Typography>
                                                    </Grid>                                                        
                                                    </>
                                                )}

                                            </>
                                            
                                        )
                                    ) : (
                                        <div className={classes.errors}>
                                            <Typography>
                                                <span>
                                                    {t(
                                                        "reservation.labels.dates-indisponibles"
                                                    )}
                                                </span>
                                            </Typography>
                                        </div>
                                    )}
                                </>
                            </Grid>
                        </>
                    ) : (
                        <CircularProgress
                            size={32}
                            style={{ color: "#890608" }}
                        />
                    )}
                </Grid>
            </Paper>
        </div>
    );
};

